import React from 'react';
import { ToastWrapper } from 'src/common/components/Toast';
import styled from 'styled-components';
import { ScreenScrapeButton } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeButton';

const Paragraph = styled.p`
  text-align: center;
  max-width: none !important;
`;

export const ScreenScrapeReconnectToast: React.FC = () => (
  <ToastWrapper kind="primary">
    <Paragraph>
      Utracono połączenie. Upewnij się, że masz połączenie z siecią internetową
      i kliknij &quot;Ponów&quot;.
    </Paragraph>
    <ScreenScrapeButton
      onClick={() => {
        window.location.reload();
      }}
    >
      Ponów
    </ScreenScrapeButton>
  </ToastWrapper>
);
